// Schmale Leiste oben, solange kein Netz da ist oder offline Abgehaktes noch nachgetragen wird (Phase 6).
import { useEffect, useState } from 'react';
import { useOhneNetz } from '../api/netz';
import { eintraegeLesen, lesen, WARTESCHLANGE_EREIGNIS } from '../api/offline';
import { useNutzerId } from '../api/rezepte';
import { Icon } from '../ui';
import s from './layout.module.css';

export function OfflineHinweis() {
  const n = useNutzerId();
  const online = !useOhneNetz();
  const [wartend, setWartend] = useState(() => Object.keys(lesen(n)).length);
  const [eintraege, setEintraege] = useState(() => eintraegeLesen(n).length);
  useEffect(() => {
    const zaehlen = () => {
      setWartend(Object.keys(lesen(n)).length);
      setEintraege(eintraegeLesen(n).length);
    };
    zaehlen();
    window.addEventListener(WARTESCHLANGE_EREIGNIS, zaehlen);
    return () => window.removeEventListener(WARTESCHLANGE_EREIGNIS, zaehlen);
  }, [n]);
  if (online && wartend === 0 && eintraege === 0) return null;
  // QA Runde 2 N1: auch offline angelegte eigene Eintraege zaehlen ("1 eigener Eintrag wartet")
  const teile = [
    wartend === 0 ? '' : wartend === 1 ? '1 abgehakte Zeile' : `${wartend} abgehakte Zeilen`,
    eintraege === 0 ? '' : eintraege === 1 ? '1 eigener Eintrag' : `${eintraege} eigene Einträge`,
  ].filter(Boolean);
  const summe = wartend + eintraege;
  const zeilen = `${teile.join(' und ')} ${summe === 1 ? 'wartet' : 'warten'}`;
  return (
    <p role="status" className={s.offline}>
      <Icon name={online ? 'haken' : 'info'} groesse={18} strich={2} />
      <span>
        {online
          ? `${zeilen} aufs Nachtragen.`
          : `Kein Netz. Du siehst den letzten Stand${summe > 0 ? `, ${zeilen} aufs Netz` : ', Abhaken geht trotzdem'}.`}
      </span>
    </p>
  );
}
